<template>
  <transition name="bbp-bounce">
    <div class="bbp-complete-project" @mouseleave="closePopup" @mouseenter="stopClose">
      <i
        class="bbp-icon-check-mark bbp-complete-project-button"
        @click.stop="setPopupPosition"
      />
      <transition name="bbp-bounce">
        <div
          v-if="popupOpen"
          class="bbp-complete-project-popup"
          @click.stop
          :style="popupPosition"
          @mouseleave="closePopup"
        >
          <div class="bbp-complete-project-popup-controls">
            <div
              v-if="button.displayed.includes(row.status)"
              :class="[
                'bbp-complete-project-popup-controls__button',
                'bbp-complete-project-popup-controls__button_completed',
                button.disabled && 'bbp-complete-project-popup-controls__button_disabled'
              ]"
              v-for="button in buttons"
              :key="button.title"
              @click.stop="changeStatus(button.value)"
            >
              {{button.title}}
            </div>
          </div>
        </div>
      </transition>
      <transition name="bbp-fade">
        <div
          v-if="isShowSubPopup"
          :style="popupPosition"
        >
          <BBPPopupInfo
            :text="textInfoPopup"
            :popupStyle="popupStyle"
            :isRevert="true"
            :isLeft="true"
            :isTextDefault="true"
            @onHandlerClick="onHandlerClick"
          />
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>

import {
  COMPLETED_PROJECT,
  SEMI_COMPLETED_PROJECT,
  PENDING_PROJECT,
  IN_PROGRESS_PROJECT
} from '@/constants/projectStatuses'
import BBPPopupInfo from '@/components/Main/BBPPopups/BBPPopupInfo'

export default {
  name: 'BBPCompleteProject',
  components: {
    BBPPopupInfo
  },
  props: ['row', 'column', 'rows'],
  data () {
    return {
      isShowSubPopup: false,
      popupOpen: false,
      popupPosition: {},
      stopClosePopup: false,
      popupStyle: {
        position: 'relative',
        pointerEvents: 'auto'
      },
      buttons: [
        {
          title: 'Pending',
          value: PENDING_PROJECT.id,
          disabled: false,
          displayed: [
            IN_PROGRESS_PROJECT.id
          ]
        },
        {
          title: 'Semi-Completed',
          value: SEMI_COMPLETED_PROJECT.id,
          disabled: false,
          displayed: [
            IN_PROGRESS_PROJECT.id,
            COMPLETED_PROJECT.id
          ]
        },
        {
          title: 'Completed',
          value: COMPLETED_PROJECT.id,
          disabled: false,
          displayed: [
            IN_PROGRESS_PROJECT.id,
            SEMI_COMPLETED_PROJECT.id
          ]
        },
        {
          title: 'Active',
          value: IN_PROGRESS_PROJECT.id,
          disabled: false,
          displayed: [
            PENDING_PROJECT.id
          ]
        }
      ]
    }
  },
  computed: {
    isSubProject () {
      const { projectType = {} } = this.row
      const { getValue } = this.column
      if (!getValue) return false
      return getValue(projectType)
    },
    textInfoPopup () {
      const { parentProject } = this.row
      const { name } = parentProject
      return `Close main hourly project > ${name}`
    }
  },
  methods: {
    onHandlerClick () {
      const { parentProjectId } = this.row

      const route = {
        name: 'ProjectCard',
        params: {
          projectId: parentProjectId
        }
      }
      this.$router.push(route)
    },
    stopClose () {
      this.stopClosePopup = true
    },
    closePopup () {
      this.stopClosePopup = false
      setTimeout(() => {
        if (!this.stopClosePopup) {
          this.popupOpen = false
          this.isShowSubPopup = false
          this.popupPosition = {}
        }
      }, 200)
    },
    setPopupPosition (e) {
      if (this.isSubProject) {
        this.isShowSubPopup = true
      } else {
        this.popupOpen = true
      }
      const position = e.target.getBoundingClientRect()
      if (position) {
        const { top, left, height } = position
        this.popupPosition = {
          position: 'fixed',
          right: 'auto',
          left: `${this.isSubProject ? left - 12 : left}px`,
          top: `${this.isSubProject ? top - height - 8 : top}px`,
          zIndex: 10
        }
      } else {
        this.popupPosition = {}
      }
    },
    changeStatus (value) {
      this.closePopup()
      this.$emit('change-status', {row: this.row, column: this.column, value: value})
    },
    setDefaultButton () {
      const { buttons = [] } = this.column
      if (buttons.length) this.buttons = buttons
      this.setDisabledButton()
    },
    setDisabledButton () {
      const { isDisabled = '' } = this.column
      if (isDisabled !== 'isProject') return
      const { typeServiceProject, totalPercent } = this.row
      this.buttons.forEach((el) => {
        if (el.value === SEMI_COMPLETED_PROJECT.id || el.value === COMPLETED_PROJECT.id) {
          el.disabled = typeServiceProject ? totalPercent !== 100 : false
        }
      })
    }
  },
  beforeMount () {
    this.setDefaultButton()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bbp-complete-project {
  @include global-font;

  &-button {
    display: flex;
    align-items: center;
    justify-content: center;
    color: $color-accent;
    width: 21px;
    height: 21px;
    font-size: 11px;
    transition: 0.3s;
    background: $color-wild-sand;
    border-radius: 50%;

    &:before {
      margin: 0;
    }

    &:hover {
      background: $color-accent;
      color: $color-white;
    }
  }

  &-popup {
    margin-left: 31px;
    background-color: $color-white;
    box-shadow: 0 0 15px rgba($color-black, 0.05);
    border-radius: 5px;
    z-index: 20;
    width: 132px;

    &-controls {

      &__button {
        color: $color-black;
        font-size: 14px;
        line-height: 17px;
        text-transform: capitalize;
        font-weight: normal;
        padding-left: 13px;

        &_completed {
          padding-top: 14px;
          padding-bottom: 10px;
          border-bottom: 1px solid $color-alabaster;
        }

        &_semi-completed {
          padding-top: 10px;
          padding-bottom: 14px;
        }

        &_disabled {
          pointer-events: none;
          opacity: 0.3;
        }

        &:hover {
          background-color: rgba($color-silver, 0.2);
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPCompleteProject/BBPCompleteProject.vue